import React, { useState, useEffect, useMemo } from 'react'
import classNames from 'classnames'
import { isEqual } from 'lodash-es'
import { Select } from '../../baseComponent/v2'
import Tooltip from '../../baseComponent/tooltip'
import util from '../../utils/util'
import Icon from '../icon'
import AuthorityIntroduced from '../authorityIntroduced'
import Checkbox from '../../baseComponent/checkbox'
import request from '../../utils/request'
import LazyLoadImage from '../../baseComponent/lazyLoadImage'
import { IDEA_MASS_ROLE, MEMBER_TYPE, ROLE_COMPARISON } from '../enum'
import GlobalSettingModal from '../globalSettingModal'
import { getTeamInfo } from '../../common/userInfo'
import { NewSearch } from '../../baseComponent/input'
import FirstTooltip from '../replaceAntd/firstTooltip'
import './cooperation.less'

export default (props) => {
  const {
    onChange,
    id,
    users,
    currentRole = IDEA_MASS_ROLE.OWNER,
    style,
    setLoading,
    usersListStyle,
    hiddenLastSet = false,
    trackSource,
    defaultHidden,
  } = props
  const [allUsers, setAllUsers] = useState([])
  const [isBatch, setIsBatch] = useState(false)
  const [visible, setVisible] = useState(false)
  const [lastUserList, setLastUserList] = useState([])
  const teamInfo = getTeamInfo()
  useEffect(() => {
    if (users?.length > 0) {
      setAllUsers(users)
    } else {
      fetchAllUsers()
    }
    fetchLastUserList()
  }, [])

  const fetchAllUsers = async () => {
    setLoading?.(true)
    try {
      const res = await request.sget(
        '/zhikuan/ins/inspiration/auth/cooperation-user-list',
        { inspirationId: id, useLastConfig: 0 },
        'MN_fetchAllUsers'
      )
      const result = res?.map(item => ({ ...item, role: item.role || IDEA_MASS_ROLE.UNSET }))
      onChange?.(result)
      setAllUsers(result)
    } catch (err) {
      console.error('cooperation-user-list', err)
    }
    setLoading?.(false)
  }
  const onLastSet = async () => {
    util.track('mn_setup_collaborate', {
      module1: trackSource,
      module2: '设置协作',
    })
    const _users = await request.get('/zhikuan/ins/inspiration/auth/cooperation-user-list', {
      params: {
        inspirationId: id,
        useLastConfig: 1,
      },
    })
    const result = _users?.map(item => ({ ...item, role: item.role || IDEA_MASS_ROLE.UNSET }))
    onChange?.(result)
    setAllUsers([...result])
  }
  const fetchLastUserList = async () => {
    const _users = await request.get('/zhikuan/ins/inspiration/auth/cooperation-user-list', {
      params: {
        inspirationId: id,
        useLastConfig: 1,
      },
    })
    const result = _users?.map(item => ({ ...item, role: item.role || IDEA_MASS_ROLE.UNSET }))
    setLastUserList(result)
  }

  const flagLast = useMemo(() => {
    return lastUserList.filter((i) => i.role).length > 1 && !isEqual(allUsers, lastUserList)
  }, [allUsers, lastUserList])

  const _onChange = (...arg) => {
    setAllUsers([...arg[0]])
    onChange(...arg)
  }

  console.log('allUsers.filter((m) => !m.role)', allUsers.filter((m) => !m.role))

  return (
    <div className="mn-idea-mass-cooperation-setting" style={style}>
      <div className="prompt-information">
        <div className="information-permissions">
          <span>权限说明</span>
          <AuthorityIntroduced defaultVisible={defaultHidden} placement="bottomLeft" currentRole={currentRole}>
            <Icon
              style={{ marginLeft: 4, verticalAlign: 'text-bottom', fontSize: 16, color: '#b8b8b8', cursor: 'pointer' }}
              type="m-xinxi_miaobian"
            />
          </AuthorityIntroduced>
        </div>
        {[MEMBER_TYPE.SUPER_ADMIN, MEMBER_TYPE.ADMIN].includes(teamInfo?.memberType) ? (
          <div onClick={() => setVisible(true)}>
            <div className="information-admin">
              <div className="tip">
                <Icon type="m-jinggao" className="icon-tip" style={{ color: 'var(--m-text-3)', marginRight: 4 }} />
                <span>需开启成员的审核权限方可允许设置为审核者</span>
              </div>
              <div className="admin-tip">
                <span>管理团队审核者</span>
                <Icon type="m-Vxing_you" className="icon-tip" style={{ color: '#0065D9' }} />
              </div>
            </div>
          </div>
        ) : (
          <div />
        )}
      </div>
      {visible && (
        <GlobalSettingModal
          visible={visible}
          onClose={() => {
            setVisible(false)
            fetchAllUsers()
          }}
        />
      )}
      <div className="users-wrap" style={usersListStyle}>
        <Users
          userList={allUsers.filter((m) => !m.role)}
          onChange={_onChange}
          fetchAllUsers={fetchAllUsers}
          setAllUsers={setAllUsers}
          id={id}
          title="未添加成员"
          isNoAdd
          currentRole={currentRole}
          isBatch={isBatch}
          setIsBatch={setIsBatch}
        />
        <Users
          userList={allUsers.filter((m) => m.role)}
          onChange={_onChange}
          fetchAllUsers={fetchAllUsers}
          setAllUsers={setAllUsers}
          id={id}
          style={{ borderLeft: 'none', paddingBottom: `${hiddenLastSet && flagLast ? '48px' : 0}` }}
          title="已添加成员"
          BatchText="批量设置权限"
          hasDelete
          currentRole={currentRole}
          isBatch={isBatch}
          setIsBatch={setIsBatch}
        />
        {
        hiddenLastSet && flagLast
          && <FirstTooltip
            contentWidth={200}
            text="点这里，快速同步上次相同设置～"
            keyValue="mn-first-tip-create-inspiration-setLast"
            onClick={onLastSet}
            className="users-wrap-use-last-set"
          >
            使用上次设置
          </FirstTooltip>
      }
      </div>
    </div>
  )
}

const Users = ({ userList = [], onChange, style, isNoAdd, setAllUsers, title, currentRole, isBatch, setIsBatch }) => {
  const [userIds, setUserIds] = useState([])
  const [sameRoles, setSameRoles] = useState([])

  const [departmentId, setDepartmentId] = useState(null)

  const hasPermission = userList?.some((item) => item?.roleOperateAccess?.length > 0)

  useEffect(() => {
    convertSameRoles(userIds)
  }, [JSON.stringify(userIds)])

  // 获取二维数组的公共部分
  const intersection = (arr) => {
    if (!arr.length) return []
    const _sameRoles = arr.reduce((data, item) => {
      return data.filter((i) => {
        return item.some((j) => {
          return i === j
        })
      })
    })
    return _sameRoles
  }

  const convertSameRoles = (_userIds) => {
    const users = _userIds.map((item) => userList.find((i) => i.userId === item))
    const roleOperates = users.map((item) => item.roleOperateAccess)
    setSameRoles(intersection(roleOperates))
  }

  const onRoleChange = (user, role) => {
    if (user.role === role) return
    user.role = role
    setAllUsers((pre) => {
      const users = [...pre]
      onChange?.(users)
      return users
    })
    if (isNoAdd || role === IDEA_MASS_ROLE.UNSET) {
      setUserIds(userIds.filter((v) => v !== user.userId))
    }
  }
  const onAddRole = (user) => {
    if (user?.roleOperateAccess?.length === 0) return
    user.role = user?.roleOperateAccess?.[0]
    setAllUsers((pre) => {
      const users = [...pre]
      onChange?.(users)
      return users
    })
    if (isNoAdd || user?.roleOperateAccess?.[0] === IDEA_MASS_ROLE.UNSET) {
      setUserIds(userIds.filter((v) => v !== user.userId))
    }
  }
  const onDeleteAll = () => {
    setAllUsers((pre) => {
      const users = pre.map((m) => {
        if (m.role != IDEA_MASS_ROLE.OWNER && m.role != currentRole) {
          return {
            ...m,
            role: IDEA_MASS_ROLE.UNSET,
          }
        }
        return m
      })
      onChange?.(users)
      return users
    })
  }
  const onRoleBatchChange = (role) => {
    if (userIds.length === 0) return
    setAllUsers((pre) => {
      const users = pre.map((m) => (userIds.includes(m.userId)
        ? {
          ...m,
          role,
        }
        : m))
      onChange?.(users)
      return users
    })
    if (isNoAdd || role === IDEA_MASS_ROLE.UNSET) {
      setUserIds([])
    }
  }

  const onSelectAll = (e) => {
    if (e.target.checked) {
      let newList = userList.filter((m) => m.role !== IDEA_MASS_ROLE.OWNER && m.role !== currentRole)
      if (departmentId) {
        newList = newList.filter((m) => m.departmentId === departmentId)
      }
      setUserIds(newList.map((m) => m.userId))
    } else {
      setUserIds([])
    }
  }

  const [keywords, setKeywords] = useState('')

  const _userList = userList.filter((item) => item.nickName.includes(keywords))
  const data = departmentId ? _userList.filter((v) => v.departmentId === departmentId) : _userList

  const onAddAll = () => {
    setAllUsers((pre) => {
      const users = pre.map((m) => {
        if (m.role === IDEA_MASS_ROLE.UNSET && data.some((item) => item.userId === m.userId)) {
          return {
            ...m,
            role: m?.roleOperateAccess?.[0],
          }
        }
        return m
      })
      onChange?.(users)
      return users
    })
  }

  return (
    <div className="users" style={style}>
      <div className="header">
        <span className="title">{title}</span>
        <span style={{ flex: 1 }} />
        {isNoAdd ? (
          <Department
            value={departmentId}
            onChange={(val) => {
              setDepartmentId(val)
              setUserIds([])
            }}
          />
        ) : null}
        {!isNoAdd && hasPermission ? (
          <div onClick={() => setIsBatch(true)} style={{ cursor: 'pointer' }}>
            <Icon type="m-piliangcaozuo" style={{ marginRight: 4, fontSize: 16 }} />
            批量操作
          </div>
        ) : null}
      </div>
      <div className="user-statistics">
        {isBatch && !isNoAdd ? (
          <BatchOptions
            setIsBatch={setIsBatch}
            userList={userList}
            departmentId={departmentId}
            currentRole={currentRole}
            userIds={userIds}
            sameRoles={sameRoles}
            onChange={onRoleBatchChange}
            onSelectAll={onSelectAll}
          />
        ) : (
          <div>
            <div style={{ padding: '8px 12px' }}>
              <NewSearch
                value={keywords}
                placeholder="点击输入名字搜索"
                onChange={(val) => setKeywords(val)}
                onClear={() => setKeywords('')}
              />
            </div>
            <div className="statistics-wrap">
              <div>
                <span>{isNoAdd ? '未选：' : '已选：'}</span>
                <span>{data.length}人</span>
              </div>
              <div>
                {isNoAdd && userList?.filter((item) => item.role === IDEA_MASS_ROLE.UNSET)?.length > 0 && hasPermission ? (
                  <span
                    className={classNames('add-all-roles', { disabled: isBatch })}
                    onClick={() => {
                      if (isBatch) return
                      onAddAll()
                    }}
                  >
                    全部添加
                  </span>
                ) : null}
                {!isNoAdd
                && userList?.filter((item) => item.role !== IDEA_MASS_ROLE.OWNER && item.role !== currentRole)?.length > 0
                && hasPermission ? (
                  <span onClick={onDeleteAll}>全部移除</span>
                  ) : null}
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="user-list">
        {data.length ? (
          data?.map((user) => (
            <div className="user" key={user.userId}>
              {!(
                user.role !== IDEA_MASS_ROLE.OWNER
                && user?.roleOperateAccess?.length > 0
                && user.role !== currentRole
                && !isNoAdd
              ) ? (
                <div style={{ width: !isNoAdd && _userList?.length > 1 && 32 }} />
                ) : isBatch ? (
                  <Checkbox
                    style={{ marginRight: 16 }}
                    checked={userIds.includes(user.userId)}
                    onChange={(e) => (e.target.checked
                      ? setUserIds((pre) => [...pre, user.userId])
                      : setUserIds((pre) => pre.filter((m) => m !== user.userId)))}
                  />
                ) : (
                  <DeleteRole user={user} onChange={onRoleChange} />
                )}
              <LazyLoadImage src={user.avatar} />
              <div className="user-name text-overflow">{user.nickName}</div>
              {user.isMarker ? (
                <Tooltip title="审核者">
                  <span className="mnshenhe" style={{ marginLeft: 4 }}>
                    <Icon type="m-shenhe" style={{ color: '#0065D9' }} />
                  </span>
                </Tooltip>
              ) : null}
              <div className="meinian-space" />
              {user.role === IDEA_MASS_ROLE.OWNER || user.role === currentRole ? (
                <div style={{ color: 'var(--m-text-3)' }}>{ROLE_COMPARISON[user.role]}</div>
              ) : isNoAdd ? (
                <AddRole user={user} onChange={onAddRole} isBatch={isBatch} />
              ) : (
                <Role user={user} onChange={onRoleChange} />
              )}
            </div>
          ))
        ) : (
          <div style={{ textAlign: 'center', marginTop: '50px' }}>暂无成员</div>
        )}
      </div>
    </div>
  )
}

export const ROLE_OPTIONS = [
  { label: '审核者', value: IDEA_MASS_ROLE.AUDITOR },
  { label: '采集者', value: IDEA_MASS_ROLE.GATHER },
  { label: '查看者', value: IDEA_MASS_ROLE.VIEWER },
]

const AddRole = (props) => {
  const { user, onChange, isBatch } = props
  return (
    <div
      className="mn-area-select"
      onClick={() => {
        if (isBatch) return
        onChange(user)
      }}
    >
      {user?.roleOperateAccess?.length > 0 ? (
        <div className={classNames('change-btn', { disabled: isBatch })}>
          <Icon type="m-tianjia_miaobian" />
        </div>
      ) : null}
    </div>
  )
}

const DeleteRole = (props) => {
  const { user, onChange } = props
  return (
    <div className="change-btn mr8" onClick={() => onChange(user, IDEA_MASS_ROLE.UNSET)}>
      <Icon type="m-guanbi" />
    </div>
  )
}

const BatchOptions = (props) => {
  const { setIsBatch, userList, departmentId, currentRole, userIds, onSelectAll, sameRoles, onChange } = props
  return (
    <div className="batch-wrap">
      <div className="batch-warp-left">
        <div className="batch-all">
          <Checkbox
            checked={
              userList
                .filter(
                  (m) => m.role !== IDEA_MASS_ROLE.OWNER
                    && m.role !== currentRole
                    && (departmentId ? m.departmentId === departmentId : m.departmentId !== departmentId)
                )
                .every((m) => userIds.includes(m.userId)) && userIds.length > 0
            }
            onChange={(e) => onSelectAll(e)}
          />
          <span className="batch-all-text">全选</span>
        </div>
        {sameRoles?.length > 0
          ? sameRoles?.map((item) => {
            return (
              <div className="batch-role-btn" onClick={() => onChange(item)}>
                {ROLE_COMPARISON[item]}
              </div>
            )
          })
          : null}
      </div>
      <div className="batch-stop" onClick={() => setIsBatch(false)}>
        取消
      </div>
    </div>
  )
}

export const Role = ({ onChange, user }) => {
  return (
    <Select
      value={user.role}
      onChange={(v) => {
        onChange(user, v.value)
      }}
      data={user?.roleOperateAccess.map((m) => ({ label: ROLE_COMPARISON[m], value: m }))}
      customText={() => {
        return (
          ROLE_OPTIONS.find((m) => m.value === user.role)?.label || <span style={{ color: 'var(--m-text-3)' }}>添加权限</span>
        )
      }}
      clearText={false}
      clearIcon={false}
    />
  )
}

export const Department = ({ onChange, value }) => {
  const [departmentList, setDepartmentList] = useState([])
  useEffect(() => {
    fetchData()
  }, [])
  const fetchData = async () => {
    const res = await request.get('/backend-api/app-dataline/data-line/department/list')
    setDepartmentList(res.map((department) => ({ ...department, label: department.departmentTitle, value: department.id })))
  }

  return (
    <Select
      value={value}
      data={[{ label: '全部部门', value: null }, ...departmentList]}
      onChange={(e) => {
        onChange(e.value)
      }}
      clearText={false}
      clearIcon={false}
    />
  )
}
